<template>
	<v-flex>
		<v-textarea
			:rows="rowsComputed"
			:error-messages="$props.error"
			:height="height"
			:label="$props.label"
			:placeholder="' '"
			:readonly="readonly"
			:type="$props.type"
			:class="{'ml-2': true, 'mr-2': true, 'text-container': true}"
			v-model="inputValue"></v-textarea>
	</v-flex>
</template>

<script>
export default {
	name: "TextArea",
	props: ['value', 'readonly', 'error', 'placeholder', 'label', 'type', 'height', 'rows'],
	data() {
		return {
			inputValue: this.$props.value
		}
	},
	computed: {
		rowsComputed() {
			if (this.$props.rows !== undefined) {
				return this.$props.rows;
			}
			return 5;
		}
	},
	watch: {
		inputValue() {
			this.$emit('input', this.inputValue);
		},
		value() {
			this.inputValue = this.$props.value;
		}
	}
}
</script>
